var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#B1CBD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D0E0E8",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 27.1666L30.8591 33.8346C31.6304 34.3746 32.0161 34.6446 32.4356 34.7492C32.8062 34.8415 33.1938 34.8415 33.5643 34.7492C33.9839 34.6446 34.3695 34.3746 35.1409 33.8346L44.6666 27.1666M26.9333 42.3333H39.0666C41.0268 42.3333 42.0069 42.3333 42.7556 41.9518C43.4142 41.6163 43.9496 41.0808 44.2852 40.4223C44.6666 39.6736 44.6666 38.6935 44.6666 36.7333V29.2666C44.6666 27.3064 44.6666 26.3264 44.2852 25.5777C43.9496 24.9191 43.4142 24.3837 42.7556 24.0481C42.0069 23.6666 41.0268 23.6666 39.0666 23.6666H26.9333C24.9731 23.6666 23.993 23.6666 23.2443 24.0481C22.5858 24.3837 22.0503 24.9191 21.7148 25.5777C21.3333 26.3264 21.3333 27.3064 21.3333 29.2666V36.7333C21.3333 38.6935 21.3333 39.6736 21.7148 40.4223C22.0503 41.0808 22.5858 41.6163 23.2443 41.9518C23.993 42.3333 24.9731 42.3333 26.9333 42.3333Z",
    stroke: "#365A6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateReport);
export default __webpack_public_path__ + "static/media/generateReport.15818bb456b8f81d2c15610837ae29ff.svg";
export { ForwardRef as ReactComponent };